(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // new
  (() => {
  const setOpen = (state) => {
    const menu = document.querySelector('.collection-menu');
    if (!menu) return;
    menu.classList.toggle('is-open', state);
    document.querySelector('.collection-menu-overlay')?.classList.toggle('is-open', state);
    document.documentElement.classList.toggle('collection-menu-locked', state);
    document.querySelector('[data-filter-open]')?.setAttribute('aria-expanded', String(state));
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-filter-open]')) setOpen(true);
    else if (event.target.closest('[data-filter-close]')) setOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });

  // If the screen is resized back to desktop, make sure the drawer state is reset
  window.matchMedia('(min-width: 993px)').addEventListener('change', (event) => {
    if (event.matches) setOpen(false);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
